import { getLogger as baseGetLogger } from '@onefootprint/logger';
import { isOnboardingSuperseded } from '@/idv2/utils/is-onboarding-superseded';

export type { ExtraProps, PrimitiveData } from '@onefootprint/logger';

import type { ExtraProps } from '@onefootprint/logger';

export {
  formatClientVersion,
  Logger as default,
  Logger,
  logClientVersion,
  setTenantLogContext,
  shouldRecordTenantSession,
  trackAction,
} from '@onefootprint/logger';

/**
 * A superseded session is a race between two concurrent onboardings, not a fault. Handlers all over
 * the flow log their failures at error level; downgrading here means none of them has to know about
 * it, and the error boundary that routes to the terminal screen stays the single reporter.
 */
export const getLogger = (...args: Parameters<typeof baseGetLogger>) => {
  const logger = baseGetLogger(...args);
  return {
    ...logger,
    logError: (message: string, error?: unknown, extra?: ExtraProps) =>
      isOnboardingSuperseded(error) ? logger.logWarn(message, error, extra) : logger.logError(message, error, extra),
  };
};
